import React from "react";

const SVG_BASE = {
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true,
};

const STROKE = {
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export function IconClover(props) {
  return (
    <svg {...SVG_BASE} {...props}>
      <path
        fill="currentColor"
        d="M12 2c-1.1 0-2 .9-2 2 0 .5.2 1 .5 1.4C9.6 5.2 8.8 5 8 5 6.3 5 5 6.3 5 8c0 .8.2 1.6.6 2.5-.4-.3-.9-.5-1.4-.5-1.1 0-2 .9-2 2s.9 2 2 2c.5 0 1-.2 1.4-.5C5.2 14.4 5 15.2 5 16c0 1.7 1.3 3 3 3 .8 0 1.6-.2 2.5-.6-.3.4-.5.9-.5 1.6 0 1.1.9 2 2 2s2-.9 2-2c0-.5-.2-1-.5-1.4.9.4 1.7.4 2.5.4 1.7 0 3-1.3 3-3 0-.8-.2-1.6-.6-2.5.4.3.9.5 1.6.5 1.1 0 2-.9 2-2s-.9-2-2-2c-.5 0-1 .2-1.4.5.4-.9.4-1.7.4-2.5 0-1.7-1.3-3-3-3-.8 0-1.6.2-2.5.6.3-.4.5-.9.5-1.6 0-1.1-.9-2-2-2z"
      />
    </svg>
  );
}

export function IconSlots(props) {
  return (
    <svg {...SVG_BASE} {...props}>
      <rect x="4.5" y="5" width="11" height="13" rx="1.5" {...STROKE} />
      <path {...STROKE} d="M8 9v5M12 9v5M16 9v5" />
      <path {...STROKE} d="M15.5 12h2.2l1.8-2.2" />
      <circle cx="19.5" cy="9.5" r="1.25" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconBonus(props) {
  return (
    <svg {...SVG_BASE} {...props}>
      <rect x="5" y="10" width="14" height="10" rx="1.5" {...STROKE} />
      <path {...STROKE} d="M12 10V7.5" />
      <path {...STROKE} d="M9.2 7.5h5.6a1.8 1.8 0 0 1 0 2.6H9.2" />
      <path {...STROKE} d="M5 14h14" />
    </svg>
  );
}

export function IconCrash(props) {
  return (
    <svg {...SVG_BASE} {...props}>
      <path
        {...STROKE}
        d="M6.5 17.5 10 8.5l5.5-2.5-2 5.5 5 1.5-4.5 1.5-2.5-4.5-5 1.5 2-5.5z"
      />
      <circle cx="14.2" cy="8.2" r="1.4" {...STROKE} />
      <path {...STROKE} d="M13 16.5 16 19" />
    </svg>
  );
}

export function IconCoins(props) {
  return (
    <svg {...SVG_BASE} {...props}>
      <ellipse cx="12" cy="6" rx="6.5" ry="2.3" {...STROKE} />
      <path
        {...STROKE}
        d="M5.5 6v3.4c0 1.55 2.91 2.8 6.5 2.8s6.5-1.25 6.5-2.8V6"
      />
      <ellipse cx="12" cy="10.8" rx="6.5" ry="2.3" {...STROKE} />
      <path
        {...STROKE}
        d="M5.5 10.8v3.4c0 1.55 2.91 2.8 6.5 2.8s6.5-1.25 6.5-2.8v-3.4"
      />
      <ellipse cx="12" cy="15.6" rx="6.5" ry="2.3" {...STROKE} />
      <path
        {...STROKE}
        d="M5.5 15.6v3.4c0 1.55 2.91 2.8 6.5 2.8s6.5-1.25 6.5-2.8v-3.4"
      />
    </svg>
  );
}

export function IconBlackjack(props) {
  return (
    <svg {...SVG_BASE} {...props}>
      <rect
        x="4"
        y="6"
        width="9"
        height="12"
        rx="1.2"
        transform="rotate(-12 8.5 12)"
        {...STROKE}
      />
      <rect
        x="11"
        y="5"
        width="9"
        height="12"
        rx="1.2"
        transform="rotate(10 15.5 11)"
        {...STROKE}
      />
      <path {...STROKE} d="M7.5 10.5h2M16 9.5h1.5M16 12h1.5" />
      <circle cx="18.5" cy="17" r="2.5" {...STROKE} />
    </svg>
  );
}

export function IconRaces(props) {
  return (
    <svg {...SVG_BASE} {...props}>
      <path {...STROKE} d="M7 4.5h10v5.2a5 5 0 0 1-10 0V4.5z" />
      <path {...STROKE} d="M7 4.5H4.2a2.4 2.4 0 0 0 2.3 4.2M17 4.5h2.8a2.4 2.4 0 0 1-2.3 4.2" />
      <path {...STROKE} d="M12 11.2v4.8" />
      <path {...STROKE} d="M8 18.5h8" />
      <path {...STROKE} d="M9.5 16.5v2M14.5 16.5v2" />
    </svg>
  );
}

export function IconWheel(props) {
  return (
    <svg {...SVG_BASE} {...props}>
      <circle cx="12" cy="12" r="7.5" {...STROKE} />
      <path {...STROKE} d="M12 4.5v15M5.2 7.8l13.6 8.4M5.2 16.2l13.6-8.4" />
      <path {...STROKE} d="M11 3.2h2v2.3h-2z" fill="currentColor" />
    </svg>
  );
}

export function IconBadge(props) {
  return (
    <svg {...SVG_BASE} {...props}>
      <path
        {...STROKE}
        strokeWidth={2}
        d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
      />
      <path
        {...STROKE}
        strokeWidth={2}
        d="m9 12 2 2 4-4"
      />
    </svg>
  );
}

export function IconZap(props) {
  return (
    <svg {...SVG_BASE} {...props}>
      <path
        {...STROKE}
        strokeWidth={2}
        d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
      />
    </svg>
  );
}

export function IconHeadphones(props) {
  return (
    <svg {...SVG_BASE} {...props}>
      <path
        {...STROKE}
        strokeWidth={2}
        d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"
      />
    </svg>
  );
}

const CAROUSEL_ICON_MAP = {
  clover: IconClover,
  slots: IconSlots,
  bonus: IconBonus,
  crash: IconCrash,
  coins: IconCoins,
  blackjack: IconBlackjack,
  races: IconRaces,
  wheel: IconWheel,
  badge: IconBadge,
  zap: IconZap,
  headphones: IconHeadphones,
};

export function HeaderCarouselIcon({ type, className }) {
  const Icon = CAROUSEL_ICON_MAP[type];
  if (!Icon) return null;
  return <Icon className={className} />;
}
